import {
  IDmLoaiThuChi,
  IDmLoaiTinChiViewModel,
} from "../../../model/respone/category/IDmLoaiThuChi";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eDmLoaiThuChiActionsObj = {
  LOAD_START: undefined,
  LOAD_SUCCESS: {} as IDmLoaiTinChiViewModel[],
  LOAD_ERRR: "",

  SAVE_START: {} as IDmLoaiThuChi,
  SAVE_SUCCESS: {} as IDmLoaiThuChi,
  SAVE_ERROR: "",

  DELETE_START: 0,
  DELETE_SUCCESS: undefined,
  DELETE_ERROR: "",

  SHOW_EDIT_MODAL: {} as undefined | IDmLoaiThuChi,
  CLOSE_EDIT_MODAL: undefined,

  SELECTED_ID: [] as number[],
  DELETE_MANY_START: [] as number[],
  DELETE_MANY_SUCCESS: undefined,
  DELETE_MANY_ERROR: "",
};
export const eDmLoaiThuChiActionIds = generateActionTypeIds(
  eDmLoaiThuChiActionsObj,
  "LOAI_THU_CHI"
);
export type IDmLoaiThuChiActionTypes = IGenericActionType<
  typeof eDmLoaiThuChiActionsObj,
  "LOAI_THU_CHI"
>;
